import { IPaginator } from 'models/paginator';
import { ILegalEntityCustomField } from 'components/organisms/LegalEntityDetails';
import { EMarkingTypes } from 'constants/Markings';

export interface IFirearmGroup {
  groupUniqueId: string;
  groupName: string;
  firearms: IFirearm[];
}

export interface IMarking {
  uniqueId: string;
  marking: string;
  markingType: EMarkingTypes;
  createdDate: string;
}

export interface IFirearm {
  uniqueId: string;
  id: string;
  serialNumber: string;
  fireCycleId: string;
  exhibitNumber: string;
  keeper: string;
  owner: string;
  makeUniqueId: string;
  typeUniqueId: string;
  actionUniqueId: string;
  frtId: string;
  frtUniqueId: string;
  manufacturedAt: string;
  manufacturerUniqueId: string;
  markings: IMarking[];
  wasImported: boolean;
  modelUniqueId: string;
  appliedMarking: string;
  caliberUniqueId: string;
  latitude: number | null;
  longitude: number | null;
  gps?: string;
  address: string | null;
  legality: string;
  firearmModel: {
    uniqueId: string;
    make: string;
    manufacturer: string;
    model: string;
  };
  firearmSpecification: {
    uniqueId: string;
    family: string;
    legalityUniqueId: string;
    caliber: string;
    shot: string;
    barrelLength: string;
    barrelType: string;
    level: string;
  };
  activityUniqueId: string;
  stateUniqueId: string;
  legalityUniqueId: string;
  customFields?: ILegalEntityCustomField[];
  detailsVisible?: boolean;
  licenceAuthorityIds: string[];
  groupName: string;
  showNoActiveLicenceWarning: boolean;
  showNoOwnerActiveLicenceWarning: boolean;
  showNoKeeperActiveLicenceWarning: boolean;
  showExpiredLinkedWarning: boolean;
  showInactiveOwnerOrKeeperWarning: boolean;
  yearOfConfiscation: string | null;
  yearOfTransfer: string | null;
}

export interface IFirearmsResponse extends IPaginator {
  content: IFirearm[];
}

export interface IFRTResponse extends IPaginator {
  content: ISingleFRT[];
}

export interface ISingleFRT {
  id: string;
  makeUniqueId: string;
  modelUniqueId: string;
  manufacturerUniqueId: string;
  actionUniqueId: string;
  typeUniqueId: string;
  countryUniqueId: string;
  frtId: string;
}

export enum EFirearmStateId {
  OWNED = 'de37bdfc-069e-11ed-b939-0242ac120002',
  EXPORTED = 'de37c1e4-069e-11ed-b939-0242ac120002',
  ASSIGNED = 'de37c306-069e-11ed-b939-0242ac120002',
  LEASED = 'de37c428-069e-11ed-b939-0242ac120002',
  RECOVERED = 'de37c52c-069e-11ed-b939-0242ac120002',
  LOST = 'de37c63a-069e-11ed-b939-0242ac120002',
  SEIZED = 'de37c748-069e-11ed-b939-0242ac120002',
  DESTROYED = '95e3c28a-8ac8-11ee-b9d1-0242ac120002',
  DISABLED = '3a8da198-8abf-11ee-b9d1-0242ac120002',
  EXPIRED = '44725660-3ec4-436a-a1a3-621026fb526f',
}
